import React from "react";

export default function VideoComponent(props) {
  return (
    <div className="w-full h-[25rem] md:h-[35rem] flex items-center justify-center py-3 videoBackground">
      <video
        controls
        muted
        className="w-full h-[20rem] md:w-[60rem] md:h-[30rem] object-contain"
        {...(props.image ? { poster: props.image } : {})}
      >
        <source src={props.video} type="video/mp4" />
      </video>
    </div>
  );
}
